module.exports = __webpack_public_path__ + "img/rotated_planar_code_annotated.5f49c5ac.svg";